module.exports = __webpack_public_path__ + "assets/0366b21f97585b53c42cc04e86ccae1b.png";